import React from 'react';
import { motion } from 'framer-motion';
interface MarqueeProps {
  text: string;
  reverse?: boolean;
}
export function Marquee({
  text,
  reverse = false
}: MarqueeProps) {
  const items = Array(8).fill(text);
  return <div className="overflow-hidden border-y border-rule/60 bg-ivory py-5 md:py-6" data-id="element-135">
      <motion.div className="flex whitespace-nowrap gap-12" animate={{
      x: reverse ? ['-50%', '0%'] : ['0%', '-50%']
    }} transition={{
      duration: 40,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-136">
        {items.concat(items).map((t, i) => <span key={i} className="flex items-center gap-12 text-3xl md:text-5xl font-sans font-light text-ink/80 tracking-tightest" data-id="element-137">
            <span data-id="element-138">{t}</span>
            <span className="w-2 h-2 rounded-full bg-red flex-shrink-0" data-id="element-139" />
          </span>)}
      </motion.div>
    </div>;
}